import axios from "axios";
import { useInfiniteQuery, useQueries, useQuery } from "react-query";

const URL = `${process.env.REACT_APP_BASE_URL}/getTopByActivityTimes?duration=year`;
const TopGeiners = () => {
  const {
    data: topdata,
    isLoading,
    error,
  } = useQuery(
    "topGainers",
    async () => await axios(URL)
  );

  type userModel = {
    index: number;
    first_name: string;
    last_name: string;
    mobile: string;
    email: string;
    avatar: string;
    level_name: number;
    duration: number;
  };

  return (
    <div>
      <section className="main-content">
        <div className="container">
          <h1>Top Gainers</h1>
          <h5>of last month</h5>
          <br />
          <br />
          <div className="row">
            {topdata &&
              topdata.data
                .filter((item: userModel) => item.index === 2)
                .map((user: userModel) => {
                  let image = require("../assets/img/default-user.png");
                    return (
                    <div key={user.index} className="col-sm-4">
                      <div
                        className="leaderboard-card second">
                        <div className="leaderboard-card__top">
                          <h3 className="text-center">{user.duration}</h3>
                        </div>
                        <div className="leaderboard-card__body">
                          <div className="text-center">
                            <img
                              key={user.index}
                              src={user.avatar ? user.avatar : image}
                              className="circle-img mb-2"
                              alt={user.mobile ? user.mobile : user.email}
                            />
                            <h5 className="mb-0">
                              {user.first_name} {user.last_name}
                            </h5>
                            <p className="text-muted mb-0">
                              {user.mobile ? user.mobile : user.email}
                            </p>
                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                <i className="fa fa-map-marker"></i>
                                {user.level_name ? user.level_name : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    );
                })}
            {topdata &&
              topdata.data
                .filter((item: userModel) => item.index === 1)
                .map((user: userModel) => {
                  let image = require("../assets/img/default-user.png");
                    return (
                    <div key={user.index} className="col-sm-4">
                      <div
                        className="leaderboard-card first">
                        <div className="leaderboard-card__top">
                          <h3 className="text-center">{user.duration}</h3>
                        </div>
                        <div className="leaderboard-card__body">
                          <div className="text-center">
                            <img
                              key={user.index}
                              src={user.avatar ? user.avatar : image}
                              className="circle-img mb-2"
                              alt={user.mobile ? user.mobile : user.email}
                            />
                            <h5 className="mb-0">
                              {user.first_name} {user.last_name}
                            </h5>
                            <p className="text-muted mb-0">
                              {user.mobile ? user.mobile : user.email}
                            </p>
                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                <i className="fa fa-map-marker"></i>
                                {user.level_name ? user.level_name : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    );
                })}
                {topdata &&
              topdata.data
                .filter((item: userModel) => item.index === 3)
                .map((user: userModel) => {
                  let image = require("../assets/img/default-user.png");
                    return (
                    <div key={user.index} className="col-sm-4">
                      <div
                        className="leaderboard-card third">
                        <div className="leaderboard-card__top">
                          <h3 className="text-center">{user.duration}</h3>
                        </div>
                        <div className="leaderboard-card__body">
                          <div className="text-center">
                            <img
                              key={user.index}
                              src={user.avatar ? user.avatar : image}
                              className="circle-img mb-2"
                              alt={user.mobile ? user.mobile : user.email}
                            />
                            <h5 className="mb-0">
                              {user.first_name} {user.last_name}
                            </h5>
                            <p className="text-muted mb-0">
                              {user.mobile ? user.mobile : user.email}
                            </p>
                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                <i className="fa fa-map-marker"></i>
                                {user.level_name ? user.level_name : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    );
                })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TopGeiners;
